import { render } from "./OrderInfo.vue?vue&type=template&id=0ffc348a&ts=true"
import script from "./OrderInfo.vue?vue&type=script&lang=ts"
export * from "./OrderInfo.vue?vue&type=script&lang=ts"

import "./OrderInfo.vue?vue&type=style&index=0&id=0ffc348a&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__